/*
    Servisa pro překlad textů z drupalu.
 */

import translations from '../data/translateTexts'

export default function (value, options = null) {
    if(window.Drupal) {
        // console.log('translating via drupal')
        return window.Drupal.t(value, options)
    }

    // if(options) {
    //     console.log(options)
    //     Object.keys(options).forEach(function(key,index) {
    //         // key: the name of the object key
    //         // index: the ordinal position of the key within the object
    //     });
    // }

    let $body = jQuery('body')

    let lang = $body.attr('data-lang')

    if (lang === 'en') {
        return value
    } else {
        var translation = translations.find(item => item.en === value)
        if(translation){
            return translation[lang]
        } else {
            return value
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/translator.js